import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import SearchQuestionsContent from './components/SearchQuestionsContent'
import Sidebar from '../../components/SideBar'

const SearchQuestions: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <SearchQuestionsContent />
      <Footer />
    </>
  )
}

export default SearchQuestions
